import Task from "../../model2/task/task";
import Event from "../../model2/event/event";
import ProjectUserFull from "../../model2/project-user/project-user-full";


export enum USER_VIEW_TYPE {
    CONFIRM             = "confirm",
    REASSIGN_ACCESS     = "reassign-access",
    REASSIGN_DELETE     = "reassign-delete",
    DEFAULT             = "default",
}


export type ReassignToUserType = {
    eventsReassignUserId    : ID
    projectReassignUserId   : ID
    tasksReassignUserId     : ID
}

export type ReassignmentDataType = {
    assignedToUserId?   : ID
    taskAssignments     : Task[]
    eventAssignments    : Event[]
    projectOwner        : ProjectUserFull[]
}
